var _path, _g, _path2, _g2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPolygon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 190,
    height: 190,
    viewBox: "0 0 190 190",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_331_25310)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_331_25310",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 188,
    height: 188
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_331_25310",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -7,
    y: -7,
    width: 204,
    height: 204
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.878 196.878H-6.87793V-6.87799H196.878V196.878Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_331_25310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.062 95C188.062 146.414 146.414 188.062 95 188.062C43.586 188.062 1.93799 146.414 1.93799 95C1.93799 43.586 43.586 1.93799 95 1.93799C146.414 1.93799 188.062 43.586 188.062 95Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_331_25310)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_331_25310",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 188,
    height: 188
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M188.138 1.862H1.90015V188.1H188.138V1.862Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_331_25310)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187.507,
    height: 186.778,
    transform: "matrix(1 0 0 -1 1.6272 188.373)",
    fill: "white"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121.904 115.064L148.238 99.864C149.644 99.066 150.48 97.546 150.48 95.95V65.55C150.48 63.954 149.606 62.434 148.238 61.636L121.904 46.436C120.498 45.638 118.788 45.638 117.382 46.436L91.0481 61.636C89.6421 62.434 88.8061 63.954 88.8061 65.55V119.89L70.3381 130.53L51.8701 119.89V98.572L70.3381 87.932L82.5361 94.962V80.674L72.6181 74.936C71.9341 74.556 71.1361 74.328 70.3761 74.328C69.5781 74.328 68.8181 74.518 68.1341 74.936L41.8001 90.136C40.3941 90.934 39.5581 92.454 39.5581 94.05V124.45C39.5581 126.046 40.4321 127.566 41.8001 128.364L68.1341 143.564C69.5401 144.362 71.2501 144.362 72.6561 143.564L98.9901 128.364C100.396 127.566 101.232 126.046 101.232 124.45V70.11L101.574 69.92L119.7 59.47L138.168 70.11V91.428L119.7 102.068L107.54 95.038V109.326L117.458 115.026C118.788 115.9 120.536 115.9 121.904 115.064Z",
    fill: "#823CDF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_331_25310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 190,
    height: 190,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPolygon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/polygon.2bc220927ca83374642a18842cc88b6c.svg";